import script from "./RelatedSummaryItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelatedSummaryItem.vue?vue&type=script&setup=true&lang=ts"

import "./RelatedSummaryItem.vue?vue&type=style&index=0&id=16683131&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16683131"]])

export default __exports__